import React, { useMemo, useRef } from "react";
import * as three from "three";
import { useThree, useFrame } from "@react-three/fiber";
//* Util
import createParticlesAttributes from "./swirlingSpirits/util/createParticlesAttributes";
//* Shaders
import { vertexShader } from "./swirlingSpirits/vertexShader";
import { fragmentShader } from "./swirlingSpirits/fragmentShader";

const SwirlingSpirits = () => {
  const { gl } = useThree();

  const particleCount = 165;
  const particleSize = 40;
  const power = 1.8;
  const width = 2.8;
  const height = 6.5;
  const depth = 3.2;

  const material = useRef<three.ShaderMaterial>(null);

  useFrame(({ clock }) => {
    if (material.current === null) return;

    material.current.uniforms.uTime.value = clock.getElapsedTime() * 0.2;
  });

  const { positions, velocities, randomness } = createParticlesAttributes(
    particleCount,
    power,
    width,
    height,
    depth
  );

  const uniforms = useMemo(
    () => ({
      uSize: {
        value: particleSize * gl.getPixelRatio(),
      },
      uTime: {
        value: 0.0,
      },
      uGravity: {
        value: -8,
      },
    }),
    [gl]
  );

  return (
    <mesh position={[0, 0, -16]}>
      <points>
        <bufferGeometry attach="geometry">
          <bufferAttribute
            attach="attributes-position"
            count={positions.length / 3}
            array={positions}
            itemSize={3}
            usage={three.DynamicDrawUsage}
          />
          <bufferAttribute
            attach="attributes-aVelocity"
            count={velocities.length / 3}
            array={velocities}
            itemSize={3}
            usage={three.DynamicDrawUsage}
          />
          <bufferAttribute
            attach="attributes-aRandomness"
            count={randomness.length}
            array={randomness}
            itemSize={1}
            usage={three.DynamicDrawUsage}
          />
          {/* <bufferAttribute
            attach="attributes-aDirection"
            count={direction.length}
            array={direction}
            itemSize={1}
            usage={three.DynamicDrawUsage}
          /> */}
        </bufferGeometry>
        <shaderMaterial
          transparent
          ref={material}
          fragmentShader={fragmentShader}
          vertexShader={vertexShader}
          uniforms={uniforms}
          depthWrite={false}
          // vertexColors={true}
          alphaTest={0.01}
          blending={three.AdditiveBlending}
        />
      </points>
    </mesh>
  );
};

export default React.memo(SwirlingSpirits);
